module.exports = __webpack_public_path__ + "static/img/b_back.092836b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/b_back.jpg?20181011
// module id = 2rqO
// module chunks = 1